import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Componente para agregar meta tags de Open Graph y Twitter Card
 * para mejorar la visualización al compartir en redes sociales
 */
const SocialMetaTags = ({ title, description, image, url }) => {
  // Asegurar que la URL de la imagen sea absoluta
  const absoluteImageUrl = image && !image.startsWith('http') 
    ? `${window.location.origin}${image}` 
    : image;
    
  // URL completa de la página actual si no se proporciona una
  const absoluteUrl = url || window.location.href;
  
  return (
    <Helmet>
      {/* Meta tags básicos */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph para Facebook, WhatsApp, etc. */}
      <meta property="og:type" content="product" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {absoluteImageUrl && <meta property="og:image" content={absoluteImageUrl} />}
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:site_name" content="Bisutería Channels" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {absoluteImageUrl && <meta name="twitter:image" content={absoluteImageUrl} />}
      
      {/* WhatsApp específico (aunque usa Open Graph) */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  );
};

export default SocialMetaTags;
